import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const usePayTypesSelector = () => useSelector((state: StateExtended) => state.userManagement.payTypes);
